/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bearing[_ngcontent-%COMP%]{width:0;height:0;border:solid transparent;-webkit-transform-origin:50% 4px;transform-origin:50% 4px;margin-top:2px}"];
export { styles as styles };
